import React from 'react';
import DataTable from 'components/Table/DataTable';

const columns = [
    {
        name: "Service",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Reference",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Period",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Cost",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Price",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "GP / Unit",
        options: {
            filter: true,
            sort: true,
        }
    }
];



class PricingTable extends React.Component {

    render() {
        return (
            <DataTable
                title={"Pricing Details"}
                data={
                    this.props.data
                        .map(stat =>
                            [
                                stat.service.name,
                                stat.product_reference,
                                (stat.end === 'never' ?
                                    'Starting ' + stat.start
                                    :
                                    'From ' + stat.start + ' to ' + stat.end
                                ),
                                stat.service.cost,
                                stat.price,
                                (stat.price - stat.service.cost)
                            ]
                        )
                }
                columns={columns}
            />
        );
    }
}

export default PricingTable;
